// app/javascript/controllers/back_to_top_controller.js

import { Controller } from "@hotwired/stimulus"
// Connects to data-controller="back-to-top"
export default class extends Controller {

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll)
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    if (window.scrollY > 300) {
      this.element.classList.add("active")
    } else {
      this.element.classList.remove("active")
    }
  }

  scrollToTop(e) {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
